import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-app/src/app/(anon)/auth/signup/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
